export const lessonPlanRoutes = {
  workspacePattern: "/salones/:classroomId/diseno-clase",
  detailPattern: "/salones/:classroomId/diseno-clase/:planId",
  workspace: (classroomId: string) => `/salones/${classroomId}/diseno-clase`,
  detail: (classroomId: string, planId: string) => `/salones/${classroomId}/diseno-clase/${planId}`,
}
